// extracted by mini-css-extract-plugin
module.exports = {"container":"cookies-module--container--qtVK1","content":"cookies-module--content--M2ly_","btn":"cookies-module--btn--Zy_7F"};